<template>
  <div>
    <v-container>
      <a-card title="帐户管理">
        <template v-if="userData.data">
          <div class="title">
            <div>姓名：{{ userData.data.name }}</div>
            <div>手机：{{ userData.data.phone }}</div>
          </div>

          <v-form ref="form" v-model="valid">
            <v-text-field v-model="userData.data.email" :rules="emailRules" label="邮箱" required></v-text-field>
            <v-text-field type="password" v-model="userData.data.password" :rules="passwordRules" label="密码" required></v-text-field>
          </v-form>

          <v-btn color="success" @click="save()">储存修改</v-btn>
        </template>
      </a-card>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {
  inject: ['reload'],
  computed: mapGetters({
    userData: 'userData'
  }),
  data() {
    return {
      valid: false,
      passwordRules: [v => !!v || '请填入密码'],
      emailRules: [v => !!v || '请填入邮箱']
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$store.dispatch('getUserData', { token: Cookies.get('member_id') })
    },
    save() {
      if (this.$refs.form.validate()) {
        let datas = {
          id: this.userData.data.id,
          email: this.userData.data.email,
          password: this.userData.data.password,
          token: this.userData.data.token
        }

        this.$message.success('更新成功')

        this.$store.dispatch('updateUserData', datas).then(() => {
          this.$router.go(0)
        })
      }
    }
  }
}
</script>